{
	"content": {
		"title": "Selectați materialele pentru care sunt necesare declarații",
		"materialListLabel": "Material",
		"materialQuantityLabel": "Cantitate material ({{unit}})",
		"availableQuantityLabel": "Cantitate disponibilă ({{unit}})",
		"carbonSavingsLabel": "Reduceri de CO\u2082 ({{unit}} CO\u2082 eq.)"
	},
	"summary": {
		"title": "Rezumat",
		"declarationTypeTitle": "Tip declarație",
		"customerProjectTitle": "Proiect client",
		"internalProjectOrProductTitle": "Proiect intern / produs",
		"projectReferenceTitle": "Referință proiect",
		"materialHeaderTitle": "Material",
		"quantityHeaderTitle": "Cantitate ({{unit}})",
		"totalTransferableCarbonReductionsTitle": "Reduceri de CO\u2082 alocabile ({{unit}})",
		"nonTransferableCarbonReductionTitle": "Reducere de CO\u2082 nealocabilă ({{unit}})"
	},
	"errorMessages": {
		"quantityRequired": "Cantitatea este obligatorie",
		"quantityPositive": "Vă rugăm să introduceți o cantitate pozitivă.",
		"quantityLargerThanAvailable": "Vă rugăm să reduceți cantitatea la totalul disponibil",
		"savingsRequired": "Reducerile de CO\u2082 sunt obligatorii",
		"fetchNotTransferedMaterialsError": "Preluarea materialelor netransferate a eșuat"
	},
	"submitTitle": "Adaugă la proiect",
	"backTitle": "Înapoi"
}
